export const CONTEXT_PATH = "/portal";